import { observer } from 'mobx-react-lite';
import Input from 'shared/elements/Input';

import { useStore } from 'models/stores';
import Field from './Field';

export default observer(({ form, required = false, field = '' }) => {
  const {
    uiStore: { t },
  } = useStore();

  return (
    <Field required={required} label={t(`apply_${field}_label`)} center>
      <Input
        value={form[field]}
        onChange={(e) => form.set(field, e.target.value)}
        error={form.errors.get(field) ? t(form.errors.get(field).error) : ''}
        disabled={form.disabled}
      />
    </Field>
  );
});
